import race_list from "./race_list";
export const CONSTANT = {
					exam: {
						status: {
							delete: { v: 0, t: "已删除" },
							enable: { v: 1, t: "可用" },
							// examining: {v:2, t: '考试中'},
							// examined: {v: 3, t: '考试完'},
							list: () => getList("exam.status"),
						},
					},

					exam_answered_paper: {
						status: {
							enable: { v: 1, t: "未交卷" },
							finish: { v: 2, t: "已交卷" },
							checked: { v: 3, t: "已批阅" },
							list: () => getList("exam_answered_paper.stats"),
						},
					},

					question: {
						type: {
							single: { v: 1, t: "单选题" },
							multiple: { v: 2, t: "多选题" },
							judge: { v: 3, t: "判断题" },
							fill: { v: 4, t: "填空题" },
							answer: { v: 5, t: "问答题" },
							list: () => getList("question.type"), // 提供填写，提示获取结构
						},
						must: {
							optional: { v: 0, t: "选做" },
							required: { v: 1, t: "必做" },
							list: () => getList("question.must"),
						},
					},

					// 部门
					department: {
						// 类型
						type: {
							business: { v: 1, t: "业务部门" },
							functional: { v: 2, t: "职能部门" },
							list: () => getList("department.type"),
						},
					},

					// 岗位
					position: {
						type: {
							instructor: { v: 1, t: "政委" },
							staff: { v: 2, t: "员工" },
							list: () => getList("position.type"),
						},
					},

					human: {
						// 员工
						staff: {
							type: {
								trial: { v: 1, t: "试用", key: "trial" }, // 感觉好像带上key比较好
								formal: { v: 2, t: "正式" },
								internship: { v: 3, t: "实习" },
								leave: { v: 4, t: "离职" },
								list: () => getList("human.staff.type"),
							},
							sex: {
								man: { v: 1, t: "男" },
								woman: { v: 2, t: "女" },
								list: () => getList("human.staff.sex"),
							},
							regist_type: {
								village: { v: 1, t: "农村户口" },
								city: { v: 2, t: "城镇户口" },
								list: () => getList("human.staff.regist_type"),
							},
							school_type: {
								//['初中及以下','高中','中专/中技','大专','本科', '硕士', 'MBA/EMBA', '博士']
								junior_school: { v: 1, t: "初中及以下" },
								high_school: { v: 2, t: "高中" },
								technical_school: { v: 3, t: "中专/中技" },
								college: { v: 4, t: "大专" },
								undergraduate: { v: 5, t: "本科" },
								master: { v: 6, t: "硕士" },
								MBA: { v: 7, t: "MBA/EMBA" },
								doctor: { v: 8, t: "博士" },
								list: () => getList("human.staff.school_type"),
							},
							degree_type: {
								full_time: { v: 1, t: "全日制教育" },
								part_time: { v: 2, t: "非全日制教育" },
								list: () => getList("human.staff.degree_type"),
							},
							political_experience: {
								party: { v: 1, t: "党员" },
								youth_league: { v: 2, t: "共青团员" },
								public: { v: 3, t: "群众" },
								list: () => getList("human.staff.political_experience"),
							},
							race_list: race_list,
							marry: {
								unmarried: { v: 1, t: "未婚" },
								has_no_child: { v: 2, t: "已婚未育" },
								has_one_child: { v: 3, t: "已育一孩" },
								has_two_children: { v: 4, t: "已育二孩" },
								has_more_children: { v: 5, t: "已育二孩以上" },
								list: () => getList("human.staff.marry"),
							},
							agreement: {
								type: {
									formal: { v: 1, t: "劳动合同" },
									internship: { v: 2, t: "实习合同" },
									list: () => getList("human.staff.agreement.type"),
								},
							},
							// 职别/职级
							grade: {
								VP: { v: 1, t: "VP" },
								director: { v: 2, t: "总监" },
								sub_director: { v: 3, t: "副总监" },
								manager: { v: 4, t: "经理" },
								department_leader: { v: 5, t: "主管" },
								employee: { v: 6, t: "专员" },
								list: () => getList("human.staff.grade"),
							},
							// 职能:
							ability: {
								finance: { v: 1, t: "财务" },
								production_manager: { v: 2, t: "产品" },
								run: { v: 3, t: "运营" },
								custom_service: { v: 4, t: "客服" },
								management: { v: 5, t: "管理" },
								technology: { v: 6, t: "技术" },
								production: { v: 7, t: "商品" },
								business: { v: 8, t: "商务" },
								design: { v: 9, t: "设计" },
								sell: { v: 10, t: "销售" },
								market: { v: 11, t: "市场" },
								human_resource: { v: 12, t: "人资" },
								list: () => getList("human.staff.ability"),
							},
						},
						// 公司
						company: {
							data: {
								lingji: { v: 1, t: "广东灵机文化传播有限公司" },
								caijie: { v: 2, t: "广州才杰计算机服务有限公司" },
								fengxinzi: { v: 3, t: "广州风信子计算机服务有限公司" },
								hule: { v: 4, t: "广州互乐计算机服务有限公司" },
								jipin: { v: 5, t: "广州吉品创意文化传播有限公司" },
								jinhui: { v: 6, t: "广州进汇网络科技有限公司" },
								meimei: { v: 7, t: "广州魅媒网络科技有限公司" },
								nuanliu: { v: 8, t: "广州暖心流网络科技有限公司" },
								qianchen: { v: 9, t: "广州前晨计算机服务有限公司" },
								shunli: { v: 10, t: "广州顺历文化创意产业有限公司" },
								tengzhi: { v: 11, t: "广州腾智网络科技有限公司" },
								xinyale: { v: 12, t: "广州欣雅乐网络科技有限公司" },
								yalesi: { v: 13, t: "广州雅乐斯计算机服务有限公司" },
								yazhuo: { v: 14, t: "广州雅卓计算机服务有限公司" },
								renxin: { v: 15, t: "仁信慈善基金会" },
								qiyuan: { v: 16, t: "广州祈愿文化传播有限公司" },
								list: () => getList("human.company.data"),
							},
							bank: {
								gongshang: { v: 1, t: "中国工商银行" },
								jianshe: { v: 2, t: "中国建设银行" },
								list: () => getList("human.company.bank"),
							},
						},
						employ: {
							apply: {
								grade: {
									low: { v: 1, t: "初级" },
									medium: { v: 2, t: "中级" },
									high: { v: 3, t: "高级" },
									list: () => getList("human.employ.apply.grade"),
								},
								priority: {
									A: { v: 1, t: "A" },
									B: { v: 2, t: "B" },
									C: { v: 3, t: "C" },
									D: { v: 4, t: "D" },
									list: () => getList("human.employ.apply.priority"),
								},
								quotas_property: {
									add: { v: 1, t: "现有编制新增" },
									supply: { v: 2, t: "现有编制补岗" },
									change: { v: 3, t: "现有编制换岗" },
									extra: { v: 4, t: "增编" },
									list: () => getList("human.employ.apply.quotas_property"),
								},
								channel: {
									boss: { v: 1, t: "BOSS直聘" },
									lagou: { v: 2, t: "拉勾" },
									wuyi: { v: 3, t: "51" },
									liepin: { v: 4, t: "猎聘" },
									shixiseng: { v: 5, t: "实习僧" },
									jianzhimao: { v: 6, t: "兼职猫" },
									lietou: { v: 7, t: "猎头" },
									neitui: { v: 8, t: "内推" },
									waibu: { v: 9, t: "外部推荐" },
									other: { v: 10, t: "其他" },
									list: () => getList("human.employ.apply.channel"),
								},
								progress: {
									filter: { v: 0, t: "邀约阶段" },
									// go_on: { v: 1, t: '进行中' },
									filter_success: { v: 8, t: "邀约成功" },
									go_on: { v: 1, t: "面试阶段" },
									done: { v: 2, t: "录用阶段" },
									// stop: { v: 3, t: '停止/暂停' },
									// pause: { v: 4, t: '暂缓' },
									join: { v: 6, t: "入职阶段" },
									leave: { v: 5, t: "离职阶段" },
									interview_success: { v: 9, t: "储备人才" },
									interview_fail: { v: 7, t: "面试未通过" },
									list: () => getList("human.employ.apply.progress"),
								},
								refuseReason: {
									//接收面试邮件但未面试原因
									can_go_on: {
										value: 8,
										label: "可跟进",
									},
									work_not_fit: {
										value: 1,
										label: "工作不匹配",
									},
									company_address: {
										value: 2,
										label: "公司地点",
									},
									work_time: {
										value: 3,
										label: "上班时间",
									},
									company_business: {
										value: 4,
										label: "公司业务",
									},
									feature: {
										value: 5,
										label: "发展规划",
									},
									work_money: {
										value: 6,
										label: "薪酬福利",
									},
									have_work: {
										value: 7,
										label: "不找工作/已有offer",
									},
									other_reason: {
										value: 0,
										label: "其它",
									},
									list: () => getList("human.employ.apply.refuseReason"),
								},
								ins: {
									type: {
										start: { v: "start", t: "审批中" },
										finish: { v: "finish", t: "审批完成" },
										terminate: { v: "terminate", t: "审批被拒绝" },
										list: () => getList("human.employ.apply.ins.type"),
									},
								},
								task: {
									type: {
										start: { v: "start", t: "审批任务开始" },
										finish: { v: "finish", t: "审批任务结束" },
										terminate: { v: "terminate", t: "审批任务被转交" },
										list: () => getList("human.employ.apply.task.type"),
									},
									result: {
										agree: { v: "agree", t: "同意" },
										refuse: { v: "refuse", t: "拒绝" },
										redirect: { v: "redirect", t: "审批任务被转交" },
										list: () => getList("human.employ.apply.task.result"),
									},
								},
							},
							interview: {
								progress: {
									zero: { v: 0, t: "等待面试" },
									// TODO:修改为（等待面试、面试中、已结束、未参加面试）这4个状态
									doing: { v: 1, t: "面试中" },
									// first: { v: 1, t: '部门初试' },
									// second: { v: 2, t: '部门复试' },
									// third: { v: 3, t: 'hr初试' },
									// forth: { v: 4, t: 'hr复试' },
									// fifth: { v: 5, t: 'hr复试结束' },
									cancel: { v: 6, t: "未参加面试" },
									over: { v: 7, t: "结束面试" },
									interview_over: { v: 8, t: "面试结束" },
									list: () => getList("human.employ.interview.progress"),
								},
								result: {
									pass: { v: 1, t: "面试通过" },
									hold: { v: 2, t: "面试结果待定" },
									fail: { v: 3, t: "面试不通过" },
									accept: { v: 4, t: "接受面试" },
									refuse: { v: 5, t: "拒绝面试" },
									list: () => getList("human.employ.interview.result"),
								},
								source: {
									talent: { v: "talent", t: "人才库来源" },
									interview: { v: "interview", t: "面试跟踪列表来源" },
									list: () => getList("human.employ.interview.source"),
								},
								send: {
									interviewer: { v: "interviewer", t: "面试官" },
									interviewee: { v: "interviewee", t: "面试人" },
									list: () => getList("human.employ.interview.send"),
								},
								// 模板类型
								template: {
									interviewer: { v: 1, t: "面试人" },
									interviewee: { v: 2, t: "面试官" },
									list: () => getList("human.employ.interview.template"),
								},
								itemResult: {
									pass: { v: 1, t: "面试通过" },
									fail: { v: 2, t: "面试不通过" },
									list: () => getList("human.employ.interview.itemResult"),
								},
								meetingRoom: {
									first_floor: { v: 1, t: "培训室" },
									three_floor_1: { v: 2, t: "自在厅" },
									three_floor_2: { v: 3, t: "菩提斋" },
									three_floor_3: { v: 4, t: "明礼舍" },
									three_floor_4: { v: 5, t: "秉義阁" },
									three_floor_5: { v: 6, t: "聚贤堂" },
									three_floor_6: { v: 7, t: "德信室" },
									three_floor_7: { v: 8, t: "怀仁轩" },
									three_floor_8: { v: 9, t: "小黑屋" },
									three_floor_9: { v: 10, t: "小卖部旁圆桌" },
									three_floor_10: { v: 11, t: "菩提斋门口圆桌" },
									other_dress: { v: 12, t: "其他" },
									list: () => getList("human.employ.interview.meetingRoom"),
								},
							},
						},
						performance: {
							plan: {
								// 新流程节点
								progressV2: {
									staff_add: { v: 1, t: "员工编辑中" },
									leader_check: { v: 2, t: "直属上级审核计划中" },
									manager_check: { v: 3, t: "部门负责人审核计划中" },
									staff_point: { v: 4, t: "员工评分中" },
									leader_point: { v: 5, t: "直属上级评分中" },
									manager_point: { v: 6, t: "部门负责人评分中" },
									instructor_check: { v: 7, t: "政委审核" },
									performance_check: { v: 8, t: "绩效岗审核" },
									vp_check: { v: 9, t: "汇总" },
									instructor_firstcheck: { v: 10, t: "政委初审" },
									support_point: { v: 11, t: "支撑组负责人评分中" },
									list: () => getList("human.performance.plan.progressV2"),
								},
								progress: {
									// all: { v: 0, t: '全部流程' },
									staff_add: { v: 1, t: "员工编辑中" },
									leader_check: { v: 2, t: "直属上级审核计划中" },
									manager_check: { v: 3, t: "部门负责人审核计划中" },
									staff_point: { v: 4, t: "员工评分中" },
									leader_point: { v: 5, t: "直属上级评分中" },
									manager_point: { v: 6, t: "部门负责人评分中" },
									instructor_check: { v: 7, t: "政委审核" },
									performance_check: { v: 8, t: "绩效岗审核" },
									vp_check: { v: 9, t: "汇总" },
									instructor_firstcheck: { v: 10, t: "政委初审" },
									support_point: { v: 11, t: "支撑组负责人评分中" },
									list: () => getList("human.performance.plan.progress"),
								},
								grade: {
									A: { v: 1, t: "A（优秀）" },
									B: { v: 2, t: "B（良好）" },
									C: { v: 3, t: "C（一般）" },
									D: { v: 4, t: "D（待改进）" },
									E: { v: 5, t: "E（不合格）" },
									list: () => getList("human.performance.plan.grade"),
								},
							},
							item: {
								progress: {
									init: { v: 1, t: "初始添加" },
									add: { v: 2, t: "自评添加" },
									event_add: { v: 3, t: "关键事件添加" },
									list: () => getList("human.performance.item.progress"),
								},
								counted: {
									disable: { v: 0, t: "计划变动，不参与计算总分" },
									enable: { v: 1, t: "参与计算总分" },
								},
								type: {
									finance: {
										v: 1,
										t: "公司财务维度(此项不用评分，由负责人统一输入财务得分)",
									},
									bussiness: {
										v: 2,
										t: "业务经营/转化维度（含用户维度、业务转化漏斗）",
									},
									progress: { v: 3, t: "内部流程维度（含项目组织与管理）" },
									organize: { v: 4, t: "组织发展维度" },
									member: { v: 5, t: "用户/会员维度" },
									satisfy: { v: 6, t: "协助效率提升/满意度" },
									optimize: { v: 7, t: "技术优化（如获量技术）" },
									document: { v: 8, t: "文档管理" },
									important: { v: 9, t: "重要工作事项" },
									study: { v: 10, t: "学习与成长" },
									temporary: { v: 11, t: "临时工作" },
									adjust: { v: 12, t: "加减分项" },
									dangerous: { v: 13, t: "高压线指标" },
									dept_finance: {
										v: 14,
										t: "部门财务维度(此项不用评分，由负责人统一输入财务得分)",
									},
									bussiness_finance: { v: 15, t: "业务(拆解后)财务维度" },
									event: { v: 16, t: "加减分项" },
									list: () => getList("human.performance.item.type"),
								},
								event: {
									positive: { v: 1, t: "正向关键事项" },
									negative: { v: 2, t: "负向关键事项" },
									list: () => getList("human.performance.item.event"),
								},
							},
						},
					},
					week: {
						Sunday: { v: 0, t: "周日" },
						Monday: { v: 1, t: "周一" },
						Tuesday: { v: 2, t: "周二" },
						Wednesday: { v: 3, t: "周三" },
						Thursday: { v: 4, t: "周四" },
						Friday: { v: 5, t: "周五" },
						Saturday: { v: 6, t: "周六" },
						list: () => getList("week"),
					},
				};

export function getList(targetKey) {
	if (!targetKey) return [];
	const tarArr = targetKey.split(".") || [];
	let target = CONSTANT;
	let i = 0;
	while (tarArr.length && i <= tarArr.length - 1) {
		let key = tarArr[i];
		target = target[key];
		i++;
	}

	if (!target) {
		return [];
	}
	let keys = Object.keys(target);
	let result = [];
	for (let key of keys) {
		if (key === "list") continue;
		result.push(target[key]);
	}
	return result;
}

export default CONSTANT;
